<template>
	<div class="container__footer">
		<label>
			{{ $t('poweredBy') }}
			<img
				src="../../assets/treevia-logo.png"
				alt
			/>
			| {{ `${$t('slogan')}. | Smartforest 2.0 | ${latestVersion}` }}
		</label>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters('moduleChangelog', ['latestVersion']),
	},
}
</script>

<style scoped>
.container__footer {
	display: flex;
	justify-content: center;
	text-align: center;
	width: 100%;
	padding: 0 2rem;
	user-select: none;
	flex-direction: row;
}

.container__footer label {
	color: #737476;
	font-size: 0.75rem;
	display: flex;
}

img {
	max-width: 20px;
}
</style>
